export const MANAGE_EMAIL_PREFERENCES = "manageEmailPreferences";
export const OVERWRITE_COPY_KEY = "overwriteCopy";
